<div class="container">
    <app-get-started
    (onOnBoardingFinished)="onOnBoardingFinishedEvent($event)"
  ></app-get-started>
</div>
  